<form [formGroup]="controlForm">
  <div class="flexCenterAlign">
    <mat-form-field class="w-p-100">
      <mat-select
        [placeholder]="tag.TagKey"
        formControlName="tagValue"
        [disabled]="disabled"
        panelClass="mat-select-panel single-select-panel-container"
        [attr.id]="buildElementId('ddl-tag-value')"
        >
        @if (tag.TagValues.length > 10) {
          <mat-form-field class="ml-10 w-p-90" appearance="outline">
            <input
              matInput
              #searchInput
              placeholder="Search"
              (input)="applyFilters($event.target.value)"
              formControlName="search"
              [disabled]="disabled"
              [attr.id]="buildElementId('fld-search')"
              />
              <i
                matSuffix
                class="removeIconPosition icon-ic-remove-doc pointCursor color-error"
                [class.disabled-clear-icon]="disabled"
                (click)="clearSearch()"
                [attr.id]="buildElementId('btn-clear-search')"
              ></i>
            </mat-form-field>
          }
          <ng-container>
            @for (option of filteredOptions; track option) {
              <mat-option [value]="option">
                {{ option }}
              </mat-option>
            }
          </ng-container>
        </mat-select>
      </mat-form-field>
      <button
        type="button"
        class="pointCursor"
        color="accent"
        mat-icon-button
        (click)="clearContent()"
        [disabled]="disabled"
        [attr.id]="buildElementId('btn-clear-tag')"
        >
        <i
          class="icon-ic-remove-doc pointCursor"
          [class.disabled-clear-icon]="disabled"
          matTooltipClass="tooltip-style"
          matTooltipPosition="above"
          matTooltip="Remove tag"
          >
        </i>
      </button>
    </div>
  </form>
